/* eslint-disable id-blacklist */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AddressSuggestion } from '../models/address.model';

@Injectable({
  providedIn: 'root',
})
export class AddressAutocompleteService {
  private apiUrl = `${environment.welbyEndpoint}/api/v1/radar/autocomplete`;

  constructor(private http: HttpClient) {}

  /**
   * Searches for addresses based on the provided query.
   *
   * @param query - The search query.
   * @returns An Observable of AddressSuggestion[].
   */
  searchAddress(query: string): Observable<AddressSuggestion[]> {
    if (!query || query.length < 3) {
      return of([]);
    }

    return this.http.get<any>(`${this.apiUrl}?query=${encodeURIComponent(query)}`).pipe(
      map((response) => {
        // Adjust this mapping based on the actual API response structure
        if (response && Array.isArray(response.addresses)) {
          const addresses = response.addresses;
          return addresses;
        }
        return [];
      }),
      catchError((error) => {
        console.error('Error in address autocomplete:', error);
        return of([]);
      })
    );
  }
}
